import gql from 'graphql-tag';

export const CREATE_VERSION = gql`
    mutation storeVersion($input: VersionInput!) {
        storeVersion(input: $input) {
            id
            identifier
            name
            revision
            configuration
            device_type_id
            version_parent_id
        }
    }
`;

export const UPDATE_VERSION = gql`
    mutation updateVersion($id: Int!, $input: VersionInput!) {
        updateVersion(id: $id, input: $input) {
            id
            identifier
            name
            revision
            configuration
            device_type_id
            version_parent_id
        }
    }
`;

export const VERSION_FILES = gql`
    query versionFiles($projectId: Int64!, $deviceTypeId: Int!, $versionId: Int!) {
        versionFiles(projectId: $projectId, deviceTypeId: $deviceTypeId, versionId: $versionId) {
            files {
                file_name
                size
                updated_at
            }
        }
    }
`;

export const CREATE_VERSION_FILE = gql`
    mutation createVersionFile($projectId: Int64!, $deviceTypeId: Int!, $versionId: Int!, $input: VersionFileInput!) {
        createVersionFile(projectId: $projectId, deviceTypeId: $deviceTypeId, versionId: $versionId, input: $input) {
            file_name
            upload_url
        }
    }
`;

export const DELETE_VERSION_FILE = gql`
    mutation deleteVersionFile($projectId: Int64!, $deviceTypeId: Int!, $versionId: Int!, $fileName: String!) {
        deleteVersionFile(projectId: $projectId, deviceTypeId: $deviceTypeId, versionId: $versionId, fileName: $fileName){
            file_name
        }
    }
`;
